export default function Features() {
  const features = [
    {
      icon: 'ri-lock-line',
      title: 'Secure Connection',
      description: 'End-to-end encryption ensures your data remains protected at all times with industry-leading security protocols.',
    },
    {
      icon: 'ri-rocket-line',
      title: 'Fast Performance',
      description: 'Optimized code and efficient algorithms deliver lightning-fast performance without compromising quality.',
    },
    {
      icon: 'ri-user-shield-line',
      title: 'User Privacy',
      description: 'We prioritize your privacy with zero-logging policies and transparent data handling practices.',
    },
    {
      icon: 'ri-layout-line',
      title: 'Clean Interface',
      description: 'Intuitive and beautiful user interfaces designed for seamless navigation and enhanced user experience.',
    },
    {
      icon: 'ri-refresh-line',
      title: 'Regular Updates',
      description: 'Continuous improvements and new features delivered through regular updates to keep apps current.',
    },
    {
      icon: 'ri-customer-service-line',
      title: '24/7 Support',
      description: 'Dedicated support team available around the clock to assist with any questions or concerns.',
    },
  ];

  return (
    <section id="features" className="py-32 bg-[#0F1419]">
      <div className="max-w-[1400px] mx-auto px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 mb-20">
          <div>
            <h3 className="text-5xl lg:text-6xl font-bold text-white leading-tight">
              Key Features
              <br />
              That Define Us
            </h3>
          </div>
          <div className="flex items-end">
            <p className="text-base text-[#A0AEC0] leading-relaxed max-w-[420px]">
              Our applications are built with cutting-edge technology and user-centric design principles to deliver exceptional experiences that users love and trust.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <div
              key={index}
              className="group bg-white/5 backdrop-blur-sm rounded-2xl p-8 hover:bg-white/10 transition-all duration-300 cursor-pointer border border-white/10"
            >
              <div className="space-y-6">
                <div className="h-1 w-12 bg-[#00D9FF] rounded-full"></div>
                
                <div className="w-12 h-12 flex items-center justify-center">
                  <i className={`${feature.icon} text-4xl text-[#00D9FF]`}></i>
                </div>

                <h4 className="text-xl font-bold text-white whitespace-nowrap">
                  {feature.title}
                </h4>

                <p className="text-sm text-[#A0AEC0] leading-relaxed">
                  {feature.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}